import { Container } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './CoreValues.css';

export interface CoreValuesProps {
  values: AboutContentDto['coreValues'];
}

export function CoreValues({ values }: CoreValuesProps) {
  if (values.length === 0) {
    return null;
  }
  return (
    <section className="dma-core-values" aria-labelledby="dma-core-values-heading">
      <Container>
        <h2 id="dma-core-values-heading">ارزش‌های سازمانی</h2>
        <ul className="dma-core-values__list">
          {values.map((value) => (
            <li key={value} className="dma-core-values__item">
              {value}
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
